module.exports = __webpack_public_path__ + "img/logo.c0b243f5.png";